angular.module('tradersyard').controller('graph-calendar-ctrl', [
    '$scope',
    'graph-webinar-factory',
    '$moment',
    function ($scope, $webinar, $moment) {
        $scope.containerSelector = '#calendar';
        $scope.nodes = [];
        $scope.events = [];
        $scope.params = {
            webinar: {
                page: 1,
                filter: 'my',
            },
            event: {
                page: 1,
                filter: 'my',
            },
        };
        $scope.process = false;

        $scope.load = {
            webinar: function () {
                $scope.process = true;
                $webinar.query('me', { params: $scope.params.webinar }).then(function (response) {
                    if (response.data.state === 0 && response.data.data.length > 0) {
                        $scope.nodes = $scope.nodes.concat(response.data.data);

                        var data = $scope.converter(response.data.data, 'webinar');
                        $scope.events = $scope.events.concat(data);

                        $($scope.containerSelector).fullCalendar('addEventSource', data);
                        $($scope.containerSelector).fullCalendar('render');

                        $scope.load.webinar();
                        ++$scope.params.webinar.page;
                    }

                    $scope.process = false;
                });
            },
        };

        $scope.converter = function (array, entry) {
            var data = [],
                url = '/' + entry + '/',
                color = {
                    webinar: '#3a87ad',
                    event: '#228B22',
                };

            angular.forEach(array, function (event) {
                data.push({
                    title: event.name,
                    url: url + event.id,
                    color: color[entry],
                    start: moment(event.started_at).format(),
                    //end  : moment(event.ended_at).format(),
                    allDay: false,
                    forceEventDuration: true,
                });
            });

            return data;
        };

        $scope.query = function () {
            $scope.load.webinar();
            $scope.calendar();
        };

        $scope.calendar = function () {
            $($scope.containerSelector).fullCalendar({
                header: {
                    left: 'month,agendaWeek,agendaDay',
                    center: 'title',
                    right: 'listWeek',
                },
                views: {
                    month: {
                        eventLimit: 2,
                    },
                },
                defaultDate: moment(),
                timezone: $moment.timezone(),
                locale: $moment.language(),
                ignoreTimezone: false,
                navLinks: true,
                editable: false,
                eventLimit: false,
                events: $scope.events,
                timeFormat: moment.localeData().longDateFormat('LT'),
            });
        };

        $scope.$on('touch:toolbox:calendar', function () {
            $scope.query();
        });

        $scope.init = function (containerSelector) {
            $scope.containerSelector = containerSelector;
            setTimeout(function () {
                $scope.query();
            }, 0);
        };
    },
]);
